import axios from "axios";
import posthog from "posthog-js";
// import Cookies from "js-cookie";

const testUrl = "https://api-staging.siai.live"
// const prodUrl = "https://api.siai.live"

export const axiosReq = axios.create({
  baseURL: testUrl,
  withCredentials: true,
});

let tokenUpdater: ((token: string, username: string, name: string) => void) | null = null;
let logoutTrigger: (() => void) | null = null;

// Register token updater function
export const registerTokenHandlers = (
  updateToken: (token: string, username: string, name: string) => void,
  logout: () => void
) => {
  tokenUpdater = updateToken;
  logoutTrigger = logout;
};

// Flags to limit the number of refresh apis called
let isRefreshing = false;
let refreshFailed = false;

// Response interceptor to handle token refresh
axiosReq.interceptors.response.use(
  (response) => {
    // Reset refresh failed flag on successful response
    refreshFailed = false;
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't tried to refresh token yet
    // and we're not already refreshing and refresh hasn't previously failed
    if (error.response?.status === 401 &&
      !originalRequest._retry &&
      !isRefreshing &&
      !refreshFailed) {

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Call refresh token endpoint
        const response = await axiosReq.post('/api/landing/token/refresh/');

        // Get new access token and username from response
        const newToken = response.data.access;
        const username = response.data.username;
        const name = response.data.name;

        if (newToken && tokenUpdater) {
          // Update token and username in context (async)
          console.log("login handler");
          tokenUpdater(newToken, username, name);

          posthog.identify(name, { username: name });

          // IMPORTANT: Use the new token immediately for the retry
          // Don't rely on context update which is async
          originalRequest.headers.Authorization = `Bearer ${newToken}`;

          // Reset flags
          isRefreshing = false;

          // Retry the original request with the new token
          return axiosReq(originalRequest);
        }
      } catch (refreshError) {
        // Mark that refresh has failed
        isRefreshing = false;
        refreshFailed = true;

        console.error('Token refresh failed:', refreshError);

        // If refresh fails, trigger logout
        if (logoutTrigger) {
          logoutTrigger();
        }
        return Promise.reject(refreshError);
      }
    }

    // If we've already tried refreshing and failed, don't try again
    if (refreshFailed && error.response?.status === 401) {
      if (logoutTrigger) {
        logoutTrigger();
      }
    }

    return Promise.reject(error);
  }
);

// Request interceptor to add auth token
export const setupAxiosInterceptors = (getToken: () => string | undefined) => {
  // Clear any existing request interceptors to avoid duplicates
  axiosReq.interceptors.request.clear();

  const requestInterceptor = axiosReq.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Check if the URL is not login or refresh
      let orgId = window.location.hostname;
      // const orgId = "self_stg.siai.live"
      // const orgId = "adidas.siai.live"
      // const orgId = "deko-stg.siai.live"
      // const orgId = "6pminparis-stg.siai.live"
      // const orgId = "chapelhill_stg.siai.live"
      // const orgId = "amymd-stg.siai.live"
      // const orgId = "yogasix.siai.live"

      if (orgId === "chapelhill_dev.siai.live") {
        orgId = "chapelhill_stg.siai.live"
      }

      if (orgId) {
        config.headers["X-Org"] = orgId;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  return requestInterceptor;
};
